import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { AgGridReact } from "ag-grid-react";
import _ from "lodash";
import "./style.css";
import "../../../common/style.css";
import {
  ColumnResizedEvent,
  FilterChangedEvent,
  FilterModifiedEvent,
  GridApi,
} from "ag-grid-community";
import "ag-grid-enterprise";
import Customtooltip from "../../../components/CustomTooltip/index";
import { onGridSizeChanged } from "../../../components/AgGrid/grid-util";
import { useLocation } from "react-router";
import { constants } from "../../../common/constants";
import {
  ColumnDtcOutDefs,
} from "../../../common/columnDTCdashboard";
import { getRowStyle } from "../../../common/commonFunctions";

interface AgGridProps {
  title?: string;
  rowData: any;
  height?: any;
  type?: string;
  onClickHan?: any;
  onClickSelectData?: any;
  onCellChange?: any;
  seTtotalSelectedRows?: any;
  getBtnRef?: any;
  getGridApi?: any;
  doesExternalFilterPass?: any;
  isExternalFilterPresent?: any;
  isDeselectAll?: boolean;
  getContextMenuItems?: any;
  globalSearch?: any;
  insertRowId?: any;
  defaultFilter?: any;
  isDataRefresh?: boolean;
  // onBtExport?:(event: React.MouseEvent<HTMLButtonElement>) => void;
}

const ContractActivityGrid = ({
  title,
  rowData,
  height,
  type,
  onClickHan,
  onClickSelectData,
  onCellChange,
  seTtotalSelectedRows,
  getBtnRef,
  getGridApi,
  doesExternalFilterPass,
  isExternalFilterPresent,
  isDeselectAll,
  getContextMenuItems,
  globalSearch,
  insertRowId,
  defaultFilter,
  isDataRefresh
}: // onBtExport,
  AgGridProps) => {
  const gridRef = useRef<any>(null);
  const [columnDefs] = useState<any>([...ColumnDtcOutDefs]);
  const [flashedRowIds, setFlashedRowIds] = useState<any>([]);
  const [selectedData, setSelectedData] = useState<any>([]);
  // const [gridApiParmas, setGridApiParams] = useState<any>(null);

  let gridApi: any;
  const defaultColDef = useMemo<any>(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: false,
      suppressFilterButton: false,
      editable: true,
      resizable: true,
      headerCheckboxSelectionFilteredOnly: true,
      tooltipComponent: Customtooltip,
      menuTabs: [constants.FilterMenuTab],
      tooltipShowDelay: 10,
      tooltipMouseTrack: true,
      suppressKeyboardEvent: (params: any) => {
        let isTabKey = params?.event?.key === constants.Tab;
        if (isTabKey) gridRef?.current?.api?.stopEditing();
        return false;
      },
    };
  }, []);

  useEffect(() => {
    gridApi = gridRef.current!.api;

    var gridColumnApi = gridRef.current!.columnApi;
    getUpdatedData(rowData);
    getName(gridApi, gridColumnApi);
    getBtnRef(gridRef);
  }, [rowData]);
  const onColumnResized = useCallback((params: ColumnResizedEvent) => { }, []);
  const onTransactionApplied = () => {
    if (insertRowId && insertRowId?.length>0) {
      const rowNodes:any[]=[]
      insertRowId?.forEach((id:any, index:any)=>{
        const rowNode = gridRef?.current?.api?.getRowNode(id);
        if (rowNode && !_.includes(flashedRowIds, id)) {
          rowNodes.push(rowNode)
        }else{
          const rowNode = gridRef?.current?.api?.getDisplayedRowAtIndex(index);
          if(rowNode)rowNodes.push(rowNode)
        }
      })
      setFlashedRowIds((previousIds: any) => [insertRowId, ...previousIds]);
      gridApi?.flashCells({ rowNodes: rowNodes });
    }
  };
  // const getUpdatedData = useCallback(
  //   async (data: any) => {
  //     await gridApi?.applyTransactionAsync(
  //       { update: [rowData] },
  //       onTransactionApplied
  //     );
  //     gridApi?.refreshCells();
  //   },
  //   [rowData]
  // );
const getUpdatedData = useCallback(
  async (updatedRows: any[]) => {
    if (gridApi && updatedRows?.length) {
      await gridApi.applyTransactionAsync({ update: updatedRows }, onTransactionApplied);
      gridApi.refreshCells({ force: true });
    }
  },
  [gridApi]
);

  useEffect(() => {
    if (defaultFilter && gridRef) {
      const filterComponent = gridRef?.current?.api?.getFilterInstance(
        defaultFilter.column
      );
      if (filterComponent) {
        filterComponent?.setModel({ values: defaultFilter.values });
        gridApi.onFilterChanged();
      }
    }
  }, [gridRef]);

  useEffect(() => {
    if (defaultFilter && gridApi) {
      setTimeout(() => {
        gridApi.setFilterModel(defaultFilter);
      }, 2000);
    }
  }, [isDataRefresh])

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
    gridApi = params.api;

    var gridColumnApi = params.columnApi;
    getName(gridApi, gridColumnApi);
    // Emmits the gridApi refrence to the parent component
    if (getGridApi) {
      getGridApi(gridApi, gridColumnApi);
    }
    if (defaultFilter && gridApi) {
      setTimeout(() => {
        gridApi.setFilterModel(defaultFilter);
      }, 2000);
    }

  };

  /**
   * Executes whenever Grid/Table filter modifies - this is more sensitive
   * @param params
   */
  const onFilterModified = (params: FilterModifiedEvent) => {
    const { api, columnApi } = params;
  };

  /**
   * Executes whenever Grid/Table filter changes
   * @param params
   */
  const onFilterChanged = (params: FilterChangedEvent) => {
    const { api, columnApi } = params;
    api.deselectAll();
    getName(api, columnApi);
  };

  const { pathname } = useLocation();
  /**
   * To skip pinned rows on the basis of Page path
   * @returns shouldSkip : boolean
   */
  const skipPinnedRow = (): boolean => {
    if (pathname && typeof pathname === "string") {
      const pathsToSkip = ["secmaster", "counterParty"];
      for (let aPath of pathsToSkip) {
        if (pathname.endsWith(aPath)) return true;
      }
    }

    //Skip for Contract Activity Popup
    if (type === constants.ContractActivity) return true;

    return false;
  };

  const getName = (api: any, columnApi: any) => {
    if (!api || !columnApi || skipPinnedRow()) return;
    let rows: any = {};
    var result = [];
    columnApi?.getAllGridColumns().forEach((item: any) => {
      rows[item.colId] = null;
    });
    let columnsWithAggregation = [
      "contract_id"
    ];
    columnsWithAggregation.forEach((element) => {
      api?.forEachNodeAfterFilter((rowNode: any) => {
        if (rowNode.data[element]) {
          rows[element] += Number(parseFloat(rowNode.data[element]));
        }
      });
    });

    let accountIdTotal = ["account_id"];
    let countAccountId_ = 0;
    accountIdTotal.forEach((element) => {
      api?.forEachNodeAfterFilter((rowNode: any) => {
        countAccountId_++;
      });
    });
    rows["account_id"] = countAccountId_;

    var count = Number(2);
    for (var i = 0; i < count; i++) {
      if (i === 0) {
        result.push({
          cptyId: "Total CPTY",
          contract_id_new: "Total Contracts",
          account_id: "Total Rows",
          isTotalRow: true,
          id: "contract-activity-id-title",
          tb_ticker: "Total Symbol",
          ticker: "Total Symbol",
        });
      } else {
        rows["isTotalRow"] = true;
        rows["cptyId"] = countUnique("cptyId", api);
        rows["contract_id_new"] = countUnique("contract_id_new", api);
        rows['id'] = "contract-activity-id-value"
        rows["tb_ticker"] = countUnique("tb_ticker", api);
        rows["ticker"] = countUnique("ticker", api);
        result.push(rows);
      }
    }
    api?.setPinnedBottomRowData(result);
  };

  /**
   * Method counts the unique value for given attribute (for filtered values also)
   * @param attribute
   * @returns unique values count
   */
  const countUnique = (attribute: string, api: GridApi): number => {
    const uniqueItemsSet: Set<any> = new Set();
    api?.forEachNodeAfterFilter((rowNode: any) => {
      if (rowNode?.data instanceof Object && attribute in rowNode.data && rowNode.data[attribute]) {
        uniqueItemsSet.add(rowNode.data[attribute]);
      }
    });
    return uniqueItemsSet.size;
  };

  useEffect(() => {
    if (isDeselectAll != undefined) gridRef.current?.api?.deselectAll();
  }, [isDeselectAll]);

  const countRows = (rowNode: any, api: GridApi): number => {
    const selectedRows: any = gridRef.current!.api.getSelectedRows();
    if (selectedRows.length === 0) {
      return 0;
    } else {
      return selectedRows.length;
    }
  };

  const countRecall = () => {
    const rowData: any = [];
    const recallCount = new Set();
    gridApi?.forEachNode((node: any) => rowData.push(node.data));
    rowData.map((obj: any) => {
      if (obj) {
        recallCount.add(obj.recall);
      }
    });
    return recallCount.size;
  };

  const rowClassRules = useMemo(() => {
    return {
      "is-new-warning": (params: any) => {
        var isNew = params.data.is_new;
        return isNew === "TRUE";
      },
      "is-new-recall": (params: any) => {
        var isNew = params.data.is_Recall;
        return isNew === "True";
      },
    };
  }, []);

  const onSelectionChanged = useCallback((params: any) => {
    const selectedRows = gridRef.current!.api.getSelectedRows();
    const { api, columnApi } = params;
    getName(api, columnApi);
    setSelectedData(selectedRows);
    let tempArray: any = [];
    gridApi = gridRef.current!.api;
    gridApi.forEachNodeAfterFilter((node: any) => {
      tempArray.push(node.data);
    });

    let rowDataClear = selectedRows.filter((val: any) => {
      return !tempArray.includes(val);
    });

    let tempClear = tempArray.filter((val: any) => {
      return !selectedRows.includes(val);
    });
    let finalClear = tempArray.filter((val: any) => {
      return !tempClear.includes(val);
    });
    if (
      tempArray.length < rowDataClear.length ||
      (tempArray.length > rowDataClear.length &&
        rowDataClear.length > 0 &&
        tempArray.length > 0)
    ) {
      setSelectedData(finalClear);
    }
    if (seTtotalSelectedRows != undefined) seTtotalSelectedRows?.(selectedRows);
    onClickHan?.(rowDataClear);
    onClickSelectData?.(finalClear);
  }, []);

  const onCellValueChanged = useCallback((event: any) => {
    let updateArray: any = [];
    event.value = event.value.toUpperCase();
    onCellChange(event.data, event.value, event.column);
    updateArray.push(event.data);

    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    gridApi?.applyTransaction({ update: updateArray });
    getName(gridApi, gridColumnApi);

    var params = {
      force: true,
      suppressFlash: true,
      columns: [event.column],
    };

    gridApi.refreshCells(params);
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 100,
      maxWidth: 200,
    };
  }, []);

  const getRowId = (params: any) => {
    if (params && params?.data) {
      if (params?.data?.activity_id) {
        return params?.data?.activity_id;
      } 
      else if (params?.data?.id) {
        return params?.data?.id;
      }
    }
    return makeid(5);
  };

  function makeid(length: any) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressColumnFilter: false,
            suppressColumnSelectAll: false,
            suppressColumnExpandAll: true,
          },
        },
      ],
      defaultToolPanel: "",
    };
  }, []);

  function isForceRefreshSelected() {
    return (document.querySelector("#forceRefresh") as HTMLInputElement)
      ?.checked;
  }
  function isSuppressFlashSelected() {
    return (document.querySelector("#suppressFlash") as HTMLInputElement)
      ?.checked;
  }
  const onGridRowDataChanged = (params: any) => {
    let refreshParams: any = {
      force: isForceRefreshSelected(),
      suppressFlash: isSuppressFlashSelected(),
    };
    gridRef.current!.api.refreshCells(refreshParams);
  };

  useEffect(() => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef?.current!.api?.refreshCells(refreshParams);
  }, [globalSearch]);

  const onDoesfilter = useCallback((node: any) => {
    console.log("here is data", node);
    doesExternalFilterPass(node);
    return true;
  }, []);
  return (
    <>
      {title !== undefined && (
        <div
          style={{ height: "6%", width:'100%' }}
          className="drag-handle py-2 title-subHeaderTitle"
        >
          {" "}
          {title}{" "}
        </div>
      )}
      <div className="ag-theme-balham" style={{ height: "94%" }}>
        <AgGridReact
          ref={gridRef}
          rowStyle={{
            justifyContent: "center",
            color: "#2D2D2D",
            fontSize: "0.75rem",
            fontWeight: "400",
            fontStyle: "normal",
          }}
          rowHeight={22}
          columnDefs={columnDefs}
          getRowId={getRowId}
          onRowDataUpdated={onGridRowDataChanged}
          rowData={rowData}
          suppressRowClickSelection={true}
          defaultColDef={defaultColDef}
          suppressAggFuncInHeader={true}
          enableCellChangeFlash={true}
          enableRangeSelection={true}
          onGridReady={onGridReady}
          onFilterModified={onFilterModified}
          onFilterChanged={onFilterChanged}
          onGridSizeChanged={onGridSizeChanged}
          onColumnResized={onColumnResized}
          rowClassRules={rowClassRules}
          onSelectionChanged={onSelectionChanged}
          rowSelection={"multiple"}
          getRowStyle={getRowStyle}
          onCellValueChanged={onCellValueChanged}
          autoGroupColumnDef={autoGroupColumnDef}
          groupSelectsChildren={true}
          groupSelectsFiltered={true}
          sideBar={sideBar}
          pivotMode={false}
          cacheQuickFilter={false}
          isExternalFilterPresent={isExternalFilterPresent}
          doesExternalFilterPass={onDoesfilter}
          getContextMenuItems={getContextMenuItems}
          quickFilterText={globalSearch}
          overlayLoadingTemplate={
            '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          }
          animateRows = {true}
        ></AgGridReact>
      </div>
    </>
  );
};

function CustomTooltip() { }

CustomTooltip.prototype.init = function (params: any) {
  var type = params.type || "primary";
  var data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
  var eGui = (this.eGui = document.createElement("div"));

  eGui.classList.add("custom-tooltip");
  this.eGui.innerHTML =
    '<div class="panel panel-' +
    type +
    '">' +
    '<div class="panel-heading">' +
    '<h3 class="panel-title">' +
    data.country +
    "</h3>" +
    "</div>" +
    '<div class="panel-body">' +
    '<h4 style="white-space: nowrap;">' +
    data.athlete +
    "</h4>" +
    "<p>Total: " +
    data.total +
    "</p>" +
    "</div>" +
    "</div>";
};

CustomTooltip.prototype.getGui = function () {
  return this.eGui;
};

export default ContractActivityGrid;
